import toast from 'react-hot-toast';

/**
 * useMutationの型引数をまとめた汎用型。
 * @TData: 成功時に受け取るデータの型 (onSuccessの第一引数)
 * @TError: エラー時に受け取るエラーの型 (onErrorの第一引数)
 * @TVariables: mutate関数に渡す変数の型
 */
export type MutationConfig<TData, TError = Error, TVariables = void> = {
  ret: TData; 
  error: TError;
  variables: TVariables;
};

/**
 * APIエラーからメッセージを抽出してトースト表示する共通関数
 * @param error キャッチしたエラーオブジェクト
 * @param defaultMessage エラー詳細が取得できなかった場合のデフォルトメッセージ
 */
export const showApiErrorToast = (error: unknown, defaultMessage: string) => {
  let errorMessage = defaultMessage;

  // 1. エラーがHTTPレスポンスエラー(AxiosErrorなど)かチェック
  if (typeof error === 'object' && error !== null && 'response' in error) {
    // 型アサーション（簡易的）
    const responseError = error as { 
      response?: { 
        status?: number;
        data?: { 
          detail?: string;
          message?: string;
          errors?: Record<string, string[]>;
        } 
      } 
    };
    const status = responseError.response?.status;
    const data = responseError.response?.data;

    if (status === 403) {
      errorMessage = "この操作を実行する権限がありません。";
    }
    else if (status === 401) {
      errorMessage = "認証の有効期限が切れました。再度ログインしてください。";
    }
    else if (data) {
      if (data.detail) {
        errorMessage = data.detail;
      } else if (data.message) {
        errorMessage = data.message;
      } else if (data.errors && typeof data.errors === 'object') {
        const firstErrorKey = Object.keys(data.errors)[0];
        errorMessage = data.errors[firstErrorKey][0];
      }
    }
  } 
  // 3. HTTPエラー以外 (コードのバグなど) の場合
  else if (error instanceof Error) {
    errorMessage = error.message;
  }

  // トースト表示
  toast.error(errorMessage);
};